import { configureStore } from '@reduxjs/toolkit'
import sidebarSlice from '../Store/Reducer-Actions/Sidebar-slice';
import AuthenticationSlice from './Reducer-Actions/AuthenticationSlice';
import  userInfoSlice  from './Reducer-Actions/userInfoSlice';
import SchoolInfoSlice from './Reducer-Actions/SchoolInfoSlice';
import AuthStatusSlices from './Reducer-Actions/AuthStatusSlice';

const store = configureStore({
  reducer: {
    sidebar: sidebarSlice,
    user : AuthenticationSlice,
    userInfo : userInfoSlice,
    school_info : SchoolInfoSlice,
    authInfo : AuthStatusSlices,
  },
});


export default store;